import { ValueGetterParams } from "ag-grid-community";
import { roundValue, safeParseFloat } from "lib/number";
import { referenceMetricValueOrCompute } from "../sibling-value-getter";
import { MetricsKind } from "../types";
import { getChildrenTotalCost } from "./total-cost";
import { getChildrenTotalRetail } from "./total-retail";
import { MergedColumnFormulaOptions } from "./types";

/**
 * This function has dependency of retail and cost values.
 * `values` is not used here, but it needs to be in the function arg since it inherits signature from other formulas
 * Formula: (TOTAL_RETAIL - TOTAL_COST) / TOTAL_RETAIL * 100
 */
export const IMU_PERCENTAGE = (
    _values: number[],
    options: MergedColumnFormulaOptions,
    gridGetterParams: ValueGetterParams
) => {
    const totalCost = referenceMetricValueOrCompute(
        () => getChildrenTotalCost(options, gridGetterParams),
        gridGetterParams,
        MetricsKind.TOTAL_COST
    );
    const totalRetail = referenceMetricValueOrCompute(
        () => getChildrenTotalRetail(options, gridGetterParams),
        gridGetterParams,
        MetricsKind.TOTAL_RETAIL
    );
    const computedValue = safeParseFloat((totalRetail - totalCost) / totalRetail, 0) * 100;

    return roundValue(computedValue, options.decimal);
};
